import { v4 as uuid } from "uuid";
import { Middleware } from 'redux'
import store from "@/redux/store";
import { messageActions } from './messageSlice';
import MessageEvent from './messageEvent';
import Message from "./message";
import CookieHelper from "helpers/cookie";
 import {logoutUser}  from "@/reducers/Authorisation";
 import { notificationActions } from '@/reducers/Notification';
import {testme} from "@/reducers/WorkProcess";
import { setData } from "@/reducers/User";
const websocketMiddleware: Middleware = store => {
  let socket;
  let tokenSend = false;
  let nIntervId;
  let timeoutId = null;
let init = false;
let connectionState = 0;

    const sendM =() => {

    }


var tabID = sessionStorage.tabID &&
            sessionStorage.closedLastTab !== '2' ?
            sessionStorage.tabID :
            sessionStorage.tabID = uuid().slice(0, 8);
sessionStorage.closedLastTab = '2';

            const myCallback =((action = null) => {

                if(nIntervId) {
                    let re = clearInterval(nIntervId);
                    nIntervId = null;
                }
                if(socket && socket.readyState == 1 && connectionState == 3) return;

                const {AuthReducer} = store.getState();
                if(AuthReducer.isAuth === false) {
                  if (!nIntervId) {
                    nIntervId = setInterval(myCallback, 5000, action);
                    return; 
                  }
                }
                if(connectionState == -990) {
                    socket = new WebSocket(process.env.REACT_APP_WS_ENDPOINT);
                    connectionState =1;
                }
                if(connectionState ==1) {
                socket.onopen = function(event) {
                    sendMessage(action);
                    //store.dispatch(messageActions.connectionEstablished());
                    connectionState = 3;

                    if(nIntervId) {
                        let re = clearInterval(nIntervId);
                        nIntervId = null;
                    }


                }
                socket.onerror = function(event) {
                  if (!nIntervId) {
                    nIntervId = setInterval(myCallback, 5000, action);
                  }
                }
                socket.onclose = function(event) {
                    if(store && socket) {
                    //store.dispatch(messageActions.stopConnecting());
//                    socket.removeEventListener("onclose", socket.onclose);
                    connectionState = 0;
                    socket = null;
                    nIntervId = setInterval(myCallback, 5000, createAuthAction() );
                    }
                    //return next(action);
                }

                socket.onmessage = function (event) {
                    store.dispatch(messageActions.receiveMessage({ event: event }));
                    //store.dispatch(notificationActions.addNotification(event))
                }
                    connectionState = 2;
                }

            });

const createAuthAction=() => {
                let action = null;
                let rawCookie = CookieHelper.getCookie("ppc_obj");
                if(typeof rawCookie != 'undefined' && rawCookie != "" ) {
                    action = {};
                    let tokenObj = JSON.parse(rawCookie);
                    if (tokenObj && tokenObj.token) {
                        let token = tokenObj.token;
                        action.uuid = tokenObj.uuid;
                        action.token = token;

                        const {AuthReducer} = store.getState();

                        if(AuthReducer !== undefined && AuthReducer.tenant !== null && AuthReducer.tenant !== undefined && AuthReducer.tenant.key !== undefined) {
                          action.tk = AuthReducer.tenant.key;
                        }
                        tokenSend = true;
                    }
                 }

                 return action;
}

    const sendMessage= ((action) => {
            if(socket) {
                let rawCookie = CookieHelper.getCookie("ppc_obj");
                if(typeof rawCookie != 'undefined' && rawCookie != "" && tokenSend == false) {
                    let tokenObj = JSON.parse(rawCookie);
                    if (tokenObj && tokenObj.token) {
                        let token = tokenObj.token;
                        action.uuid = tokenObj.uuid;
                        action.token = token;

                        const {AuthReducer} = store.getState();

                        if(AuthReducer !== undefined && AuthReducer.tenant !== null && AuthReducer.tenant !== undefined && AuthReducer.tenant.key !== undefined) {
                          action.tk = AuthReducer.tenant.key;
                        }
                        tokenSend = true;
                    }
                } else if(typeof rawCookie == 'undefined' && tokenSend == true) {
                    action.removeToken = true;
                    tokenSend = false;
                }
                action.tabID = tabID;
                socket.send( JSON.stringify(action));
            }
	});
	/*
  document.addEventListener('mousemove', function(event){
   if (timeoutId === null) {

    if(socket && connectionState == 3) {
      timeoutId = setTimeout(() => {
        let data = {type:"TEST", payload: {x:event.clientX, y: event.clientY, vh:document.documentElement.offsetHeight, vw: document.documentElement.offsetWidth,
        scrollHeight: document.documentElement.scrollHeight, scrollTop: document.documentElement.scrollTop, scrollTopMax: document.documentElement.scrollTopMax,
        scrollWidth: document.documentElement.scrollWidth, scrollLeft: document.documentElement.scrollLeft, scrollLeftMax: document.documentElement.scrollLeftMax
        }, tabID:tabID}
        socket.send( JSON.stringify(data));

        timeoutId = null;

      }, 100);
   }
    }    //
})
*/

	return next => action => {
        if(action?.type && action?.type == "chat/receiveMessage" ) {
            let data = JSON.parse(action.payload.event.data);
            
            //store.dispatch( setData(data.payload));

            //console.log("rrrreerrere", store.dispatch(testme())  )
            }
        if(action?.type && action?.type == "chat/receiveMessage2" ) {
                action.tabID = tabID;
                if(socket && connectionState == 3) {
                socket.send( JSON.stringify(action));
                }
        }
        if(action?.type && action?.type == "USER_LOGOUT/fulfilled" ) {
            if(socket && connectionState == 3) {
                action.tabID = tabID;
                socket.send( JSON.stringify(action));
            }
        }
        if((action?.type && (action?.type == "USER_LOGIN/fulfilled" || action?.type == "USER_CHECKAUTH/fulfilled")) && !socket) {
            if(connectionState == 0) {
                myCallback(action);
            } else if(connectionState == 3) {
                if(socket) {
                    if(action?.type == "USER_CHECKAUTH/fulfilled") {
                        socket.send( JSON.stringify(createAuthAction()));
                    } else {
                                        action.tabID = tabID;

                    socket.send( JSON.stringify(action));
                    }
                }
            }
        } else if((action?.type && (action?.type == "USER_LOGIN/fulfilled" || action?.type == "USER_CHECKAUTH/fulfilled")) && socket) {
                if(socket) {
                    if(action?.type == "USER_CHECKAUTH/fulfilled") {
                        socket.send( JSON.stringify(createAuthAction()));
                    } else {
                                        action.tabID = tabID;

                    socket.send( JSON.stringify(action));
                    }
                }
            } else if((action?.type && (action?.type == "switchtenant/fulfilled" )) && socket) {
                    if(socket && connectionState == 3) {
                        action.tabID = tabID;
                        socket.send( JSON.stringify(action));
                    }

                }
        return next(action);
		const isConnectionEstablished = socket && store.getState().chat.isConnected;
			if(!init && !isConnectionEstablished && process && process.env && process.env.REACT_APP_WS_ENDPOINT && process.env.REACT_APP_WS_ENDPOINT != "" ) {
                const {AuthReducer} = store.getState();
                if(AuthReducer.isAuth) {
                try {
				socket = new WebSocket(process.env.REACT_APP_WS_ENDPOINT);
				} catch(err) {
                    
                }
				init = true;
				}
			}
		if (messageActions.startConnecting.match(action)) {
			/*
			let rawCookie = CookieHelper.getCookie("mmev_obj");
			if(typeof rawCookie != 'undefined') {
				let tokenObj = JSON.parse(rawCookie);
				if (tokenObj && tokenObj.token) {
					let token = tokenObj.token;
					socket = new WebSocket("ws://mmv_api.dev.nl:81/ws/circufyapp?token="+token);
				}
			}
			*/
			if(socket) {
				socket.onopen = function(event) {
					sendMessage(action);
                    //store.dispatch(messageActions.connectionEstablished());

				}
				socket.onerror = function(event) {
                  if (!nIntervId) {
                    nIntervId = setInterval(myCallback, 5000);
                  }
                }
				socket.onclose = function(event) {
                    if(store && socket) {
					//store.dispatch(messageActions.stopConnecting());
					socket = null;
					}
					//return next(action);
				}

	/*
				socket.on(MessageEvent.SendAllMessages, (messages: Message[]) => {
					store.dispatch(messageActions.receiveAllMessages({ messages }));
				})

				socket.on(MessageEvent.ReceiveMessage, (message: Message) => {
					store.dispatch(messageActions.receiveMessage({ message }));
				})
	*/
				socket.onmessage = function (event) {
					store.dispatch(messageActions.receiveMessage({ event: event }));
					//store.dispatch(notificationActions.addNotification(event))
				}
			}
		}
		if (messageActions.submitMessage.match(action) && isConnectionEstablished) {
			sendMessage(action);
		}
		next(action);
    }

}

export default websocketMiddleware;
